import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Table } from "reactstrap";
import { H5 } from "../../../AbstractElements";
import {
  Amount,
  Balance,
  DueDate,
  Invoice,
  InvoiceDate,
  Name,
  PaymentDues,
} from "../../../Constant";
import HeaderCard from "../../Common/Component/HeaderCard";
import { Link } from "react-router-dom";
import { getDataWithToken } from "../../../Utils/restUtils";
import { getPaymentDueSubscription } from "../../../CommonURL";
import { toast } from "react-toastify";

const Payment = ({ industryId, year }) => {
  const [paymentDueData, setPaymentDueData] = useState([]);

  useEffect(() => {
    recentPayData();
  }, [industryId, year]);
  const recentPayData = async () => {
    let url = getPaymentDueSubscription;

    const params = [];
    if (industryId) params.push(`industry_type_id=${industryId}`);
    if (year) params.push(`year=${year}`);

    if (params.length) {
      url = `${getPaymentDueSubscription}?${params.join("&")}`;
    }

    const data = await getDataWithToken(url);
    if (data?.status) {
      setPaymentDueData(data?.data?.data);
    } else {
      toast.error(data?.message);
    }
  };

  return (
    <Fragment>
      <Col xs="12">
        <Card className="transaction-history" style={{ height: "400px" }}>
          <HeaderCard title={PaymentDues} setting={true} />
          <CardBody>
            <div
              className="table-responsive sroller-style"
              style={{ height: "350px", overflowY: "auto" }}
            >
              <Table className="table table-bordernone table-responsive">
                <thead>
                  <tr>
                    <th>{Name}</th>
                    <th>{Invoice}</th>
                    <th>{Amount}</th>
                    <th>{InvoiceDate}</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentDueData?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <Link
                            style={{ color: "#5F0F40", marginLeft: "13px" }}
                            to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${item.id}`}
                          >
                            <H5>{item.user_name}</H5>
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${item.user_id}&order_id=${item.order_id}`}
                          >
                            {item.invoice_number}
                          </Link>
                        </td>
                        <td>
                          <H5>${item.amount}</H5>
                        </td>
                        <td>
                          <H5>{item.invoice_date}</H5>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <div className="text-end mt-3 pb-3 ml-9">
                <Link
                  to={`${process.env.PUBLIC_URL}/subscriptions/paymentDueSubscription`}
                  style={{
                    color: "#5F0F40",
                    fontWeight: "600",
                    textDecoration: "none",
                  }}
                >
                  View More →
                </Link>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default Payment;
